/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ThreeArguments } from "./ThreeArguments";

export class ThreeArgumentsFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ThreeArguments> {
    return super.deploy(overrides || {}) as Promise<ThreeArguments>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ThreeArguments {
    return super.attach(address) as ThreeArguments;
  }
  connect(signer: Signer): ThreeArgumentsFactory {
    return super.connect(signer) as ThreeArgumentsFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ThreeArguments {
    return new Contract(address, _abi, signerOrProvider) as ThreeArguments;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "argumentOne",
        type: "string",
      },
      {
        indexed: false,
        internalType: "int8",
        name: "argumentTwo",
        type: "int8",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "argumentThree",
        type: "bool",
      },
    ],
    name: "ThreeArgumentsCalled",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "argumentOne",
        type: "string",
      },
      {
        internalType: "int8",
        name: "argumentTwo",
        type: "int8",
      },
      {
        internalType: "bool",
        name: "argumentThree",
        type: "bool",
      },
    ],
    name: "threeArguments",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b5061017b806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c80639280b90514610030575b600080fd5b6100c06004803603606081101561004657600080fd5b810190808035906020019064010000000081111561006357600080fd5b82018360208201111561007557600080fd5b8035906020019184600183028401116401000000008311171561009757600080fd5b9091929391929390803560000b90602001909291908035151590602001909291905050506100c2565b005b7fd589183661fa75f94e2db32f4eb7ebb50f4154c160e15eb43f772a46f360a3a88484848460405180806020018460000b60000b8152602001831515151581526020018281038252868682818152602001925080828437600081840152601f19601f8201169050808301925050509550505050505060405180910390a15050505056fea264697066735822122066c85d6d755d9e9b2acf7174edb1de154f70c1b1880da4b517046c4cf33b90e564736f6c63430006040033";
